module.exports = __webpack_public_path__ + "img/level_two.5ad06192.png";